/* Milo & Nani: display only; native variants and cart remain owned by the theme. */
(() => {
  if (customElements.get('mn-limited-color-controller')) return;
  const normalize = value => value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr');
  customElements.define('mn-limited-color-controller', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      const root = this.closest('.product-form');
      if (!root) return;
      const abort = this._abort = new AbortController();
      const limited = new Set(['Terracotta', 'Safran', 'Beige Sable'].map(normalize));
      let interacted = false;
      const hostSelector = '[data-mn-limited-color-host]';
      const colorInput = target => {
        if (!(target instanceof Element)) return null;
        const host = target.closest(hostSelector);
        if (!host || !root.contains(host)) return null;
        const label = target.closest('label[for]');
        const input = target.matches('input[type="radio"]') ? target : label && document.getElementById(label.htmlFor);
        return input && host.contains(input) && !input.disabled ? input : null;
      };
      const sync = preferred => {
        const host = root.querySelector(hostSelector);
        if (!host) return;
        const input = preferred && host.contains(preferred) ? preferred : host.querySelector('input[type="radio"]:checked');
        const availability = host.querySelector('.mn-availability-note');
        if (availability) {
          const ids = (availability.dataset.mnAvailabilityIds || '').split(',').map(value => value.trim()).filter(Boolean);
          const available = !!input && ids.includes(input.value);
          if (availability.hidden === available) availability.hidden = !available;
        }
        const label = input && Array.from(host.querySelectorAll('label[for]')).find(item => item.htmlFor === input.id);
        const name = label && label.querySelector('.visually-hidden');
        const visible = interacted && !!name && limited.has(normalize(name.textContent));
        const note = host.querySelector('.mn-limited-color-note');
        if (note && note.hidden === visible) note.hidden = !visible;
      };
      const reset = () => { interacted = false; sync(); };
      root.addEventListener('click', event => {
        const input = event.isTrusted && colorInput(event.target);
        if (!input) return;
        interacted = true;
        sync(input);
      }, { capture: true, signal: abort.signal });
      root.addEventListener('change', event => {
        const input = colorInput(event.target);
        if (!input) return;
        if (event.isTrusted) interacted = true;
        sync(input);
      }, { signal: abort.signal });
      this._observer = new MutationObserver(() => sync());
      this._observer.observe(root, { childList: true, subtree: true });
      for (const type of ['pagehide', 'pageshow', 'popstate']) {
        window.addEventListener(type, reset, { signal: abort.signal });
      }
      reset();
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      this._abort = null;
    }
  });
})();
